import { useDispatch, useSelector } from 'react-redux';
import { changeStepAvailability } from './stepper.slice';

export default function usePaths() {
  const paths = { ...useSelector((state) => state.paths) };

  const dispatch = useDispatch();

  const getPath = (step) => paths[step];

  const changeAvailability = (step, available) => {
    const path = { ...getPath(step) };
    path.available = available;
    paths[step] = path;
    dispatch(changeStepAvailability(paths));
  };

  const eneableStep = (step) => {
    changeAvailability(step, true);
  };

  const disableStep = (step) => {
    changeAvailability(step, false);
  };

  return {
    paths,
    eneableStep,
    disableStep,
  };
}
